import LinkDialog from './LinkDialog'

export default {
	props: {
		value: {
			type: Object,
			default: {
				cms: true,
				itemId: null,
				title: '',
				url: '',
				newWindow: false,
				fileType: null,
				description: '',
			}
		}
	},

	data() {
		return {
			env: zzl,
			inEdit: false
		}
	},

	components: {
		LinkDialog
	},

	template: `
		<div class="index-link-item">
			<div class="index-link-item-title">
				<template v-if="value.title !== ''">
					{{value.title}}
				</template>
				<template v-else>
					<span class="text-muted">リンク未設定</span>
				</template>
				<div class="index-link-item-description">{{value.description}}</div>
			</div>
			<template v-if="value.url !== ''">
				<a v-if="editURL" :href="editURL" class="index-section-item-btn index-link-item-open" target="_blank" title="ページを編集">
					<span class="glyphicon glyphicon-edit" aria-label="ページを編集"></span>
				</a>
				<a v-else :href="linkURL" class="index-section-item-btn index-link-item-open" target="_blank" rel="noopener nofollow" title="リンクを開く">
					<span class="glyphicon glyphicon-new-window" aria-label="リンクを開く"></span>
				</a>
			</template>
			<span class="index-section-item-btn" @click="startEdit" title="編集">
				<span class="glyphicon glyphicon-cog" aria-label="編集"></span>
			</span>
			<LinkDialog v-if="inEdit" :value="value"
				@commit="commitEdit"
				@cancel="cancelEdit"
			>
			</LinkDialog>
		</div>
	`,

	computed: {
		editURL() {
			const { itemId } = this.value
			const m = String(itemId).match(/^(\w+)_([0-9]+)$/, '')
			if (!itemId) return null
			const [, type, id] = m
			if (type === 'media') return this.env.appBase + '/media/' + id + '/'
			if (type === 'page') return this.env.appBase + '/page/' + id + '/edit'
			return null
		},
		linkURL() {
			const { url } = this.value
			if (/^[/]/.test(url)) return zzl.pubOrigin + url
			return url
		},
	},

	methods: {
		startEdit() {
			this.inEdit = true
		},
		commitEdit(values) {
			this.$emit('input', values)
			this.inEdit = false
		},
		cancelEdit() {
			this.inEdit = false
		}
	}
}
